import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { ScannerComponent } from './scanner.component';
import { AuthGuardService } from '../shared/services/auth-guard.service';
import { DenyNonStaffService } from '../shared/services/deny-non-staff.service';

@NgModule({
  imports: [
    SharedModule,
    RouterModule.forChild([
      { path: 'scanner', component: ScannerComponent, canActivate:[AuthGuardService, DenyNonStaffService] }
    ])
  ],
  declarations: [ScannerComponent]
})
export class ScannerModule { }



// WEBPACK FOOTER //
// ./src/app/scanner/scanner.module.ts